// src/services/orderService.js
// FIXED: Removed broken [res.data](http://res.data) markdown link syntax

import api from './api';

export const orderService = {
  getAllOrders: async () => {
    try {
      const res = await api.get('/orders');
      return res.data;
    } catch (error) {
      console.error('Get orders error:', error);
      throw error.response?.data || error;
    }
  },

  getOrder: async (orderId) => {
    try {
      const res = await api.get(`/orders/${orderId}`);
      return res.data;
    } catch (error) {
      console.error('Get order error:', error);
      throw error.response?.data || error;
    }
  },
};